import {
  StyledAppCard,
  StyledMiniInfoDesc,
  StyledMiniInfoText,
  StyledMiniInfoTitle,
  StyledMiniInfoWrapper,
} from "./index.styled";
import { Avatar, Skeleton } from "antd";
import GrowText, { GrowTextProps } from "./RightMenu/GrowText";
import NewText, { NewTextProps } from "./RightMenu/NewText";
import { AppCardProps } from "@lib/components/AppComponents/AppCard";

type RightMenu =
  | { key: "grow"; data: GrowTextProps }
  | { key: "new"; data: NewTextProps };

export type MiniInfoType = {
  icon?: JSX.Element;
  img?: string;
  title?: string | number | JSX.Element;
  desc?: string | number | JSX.Element;
  color?: string;
  colorType?: "dark" | "transparent";
  rightMenu?: RightMenu;
};

type Props = {
  data: MiniInfoType;
  loading?: boolean;
  navigate?: () => void;
  cardProps?: AppCardProps;
};

const MiniInfoCard = ({ data, loading, navigate, cardProps }: Props) => {
  const { img, icon, title, desc, color, colorType = "dark", rightMenu } = data;

  const RightMenu = ({ data }: { data: RightMenu }) => {
    switch (data.key) {
      case "grow":
        return <GrowText loading={loading} data={data.data} />;

      case "new":
        return (
          <NewText
            loading={loading}
            data={{ ...data.data, color, colorType }}
          />
        );

      default:
        return null;
    }
  };

  return (
    <StyledAppCard
      className="card-hover no-card-space-ltr-rtl"
      style={navigate ? { cursor: "pointer" } : {}}
      {...cardProps}
      onClick={() => {
        if (navigate) navigate();
      }}
    >
      <StyledMiniInfoWrapper color={color}>
        {(img || icon) && (
          <Avatar icon={icon} src={img} className={`info-icon ${colorType}`} />
        )}

        <StyledMiniInfoText rightMenu={!!rightMenu}>
          {title && (
            <StyledMiniInfoTitle>
              {loading ? <Skeleton.Input active size="small" /> : title}
            </StyledMiniInfoTitle>
          )}
          {desc && (
            <StyledMiniInfoDesc ellipsis>
              {loading ? <Skeleton.Input active size="small" /> : desc}
            </StyledMiniInfoDesc>
          )}
        </StyledMiniInfoText>

        {rightMenu && (
          <div className="right-menu">
            <RightMenu data={rightMenu} />
          </div>
        )}
      </StyledMiniInfoWrapper>
    </StyledAppCard>
  );
};

export default MiniInfoCard;
